/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManagerKiosk {
    angular.module("meevo.plugins.walkinManagerKiosk", []);
}